module.exports = __webpack_public_path__ + "static/Renovation-3abc820555da3429f6804779fc22c2f2.jpg";